import BaseRepositoryService from 'uplisting-frontend/services/repositories/-base';
import type { ModelRegistry } from 'ember-data/types/registries/model';

export default class StayRepositoryService extends BaseRepositoryService<
  ModelRegistry['stay']
> {
  recordName = 'stay';
  implementMethods = ['query', 'unloadAll'];
}

declare module '@ember/service' {
  interface Registry {
    'repositories/stay': StayRepositoryService;
  }
}
